// Copyright 2025, University of Maryland, All Rights Reserved
interface RawDataDebugProps {
  data: any;
}

export function RawDataDebug({ data }: RawDataDebugProps) {
  return (
    <details className="bg-gray-50 p-4 rounded-xl">
      <summary className="cursor-pointer font-medium text-gray-700 mb-2">
        Raw Analysis Data (Click to expand)
      </summary>
      <pre className="text-xs overflow-auto bg-gray-100 p-4 rounded-lg max-h-96">
        {JSON.stringify(data, null, 2)}
      </pre>
    </details>
  );
}
